import { captureException, withScope } from '@sentry/react';
import { SentryNotifierException } from '~/store/middlewares/sentryNotifier/sentryNotifier.exception';
import { RejectedRTKAction } from '~/store/middlewares/sentryNotifier/sentryNotifier.type';
import { isRejected, Middleware } from '@reduxjs/toolkit';
import { isSentryNotifierExcludedEndpoint } from '~/store/middlewares/middleware.helper';

export const sentryNotifierMiddleware: Middleware = () => (next) => async (
  action
) => {
  if (!isRejected(action)) {
    return next(action);
  }

  const rejectedRTKAction = action as RejectedRTKAction;

  if (!rejectedRTKAction.meta.arg.endpointName) {
    return next(action);
  }

  if (
    isSentryNotifierExcludedEndpoint(rejectedRTKAction.meta.arg.endpointName)
  ) {
    return next(action);
  }

  const status =
    rejectedRTKAction.payload?.originalStatus ||
    rejectedRTKAction.payload?.status;

  const errorMessage =
    rejectedRTKAction.payload?.data?.message ||
    rejectedRTKAction.payload?.error;

  withScope((scope) => {
    scope
      .setTransactionName(rejectedRTKAction.meta.arg.endpointName)
      .setFingerprint([
        rejectedRTKAction.type,
        rejectedRTKAction.meta.arg.endpointName,
      ])
      .setTags({
        'endpoint.name': rejectedRTKAction.meta.arg.endpointName,
        'endpoint.status': status,
        'endpoint.path': rejectedRTKAction.meta.baseQueryMeta?.request.url,
      })
      .setExtras({
        args: rejectedRTKAction.meta.arg.originalArgs,
        response: rejectedRTKAction?.payload?.data,
      });

    captureException(
      new SentryNotifierException(`[STATUS:${status}]: ${errorMessage}`)
    );
  });

  return next(action);
};
